import React, { useState } from 'react';
import Header from '../component/Header';
import Sidebar from '../component/Sidebar';
import Balance from '../component/withdraw/Balance';

const Withdraw = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
         <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
            <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block w-full lg:w-1/6 fixed left-0 top-0 h-full z-50`}>
                <Sidebar toggleSidebar={toggleSidebar} />
            </div>

            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={toggleSidebar}
                ></div>
            )}

            <div className='flex flex-col w-full space-y-4 lg:ml-[16.67%]'>
                <div>
                     <Header 
                       isSidebarOpen={isSidebarOpen} 
                       toggleSidebar={toggleSidebar} 
                       title='Withdraw Funds'
                     />  
                </div>

                <div className='w-full p-4 lg:p-[30px] instrument-sans-medium min-h-screen'>
                    <Balance />
                </div>
            </div>
       </div>
    );
};

export default Withdraw;